/*
 * (c) Copyright, 2008-2015 Massachusetts Institute of Technology.
 *
 *     This material may be reproduced by or for the
 *     U.S. Government pursuant to the copyright license
 *     under the clause at DFARS 252.227-7013 (June, 1995).
 */
define([], function() {
	/**
	 * A very simple filtered version of OpenLayer's Collection class.
	 * 
	 * Note: this is not a complete Collection implementation, and stops at
	 * implementing the common accessors.
	 */
	var FilteredCollection = function(collection, filter) {
		this.collection = collection;
		this.filter = filter;
	};
	
	FilteredCollection.prototype.forEach = function(callback, opt_this) {
		this.collection.forEach(function(item){
			if (this.filter(item)) {
				callback.call(opt_this, item);
			}
		}.bind(this));
	};
	
	FilteredCollection.prototype.getArray = function() {
		return this.collection.getArray().filter(function(item){
			return this.filter(item);
		}, this);
	};
	
	return FilteredCollection;
});